import { Component, OnInit, OnDestroy, AfterViewInit} from '@angular/core';

import { ISubscription } from 'rxjs/Subscription';

import Handsontable from 'handsontable';
import { HotRegisterer } from 'angular-handsontable';

import {Report} from '../shared/report.model';
import {ReportDataService} from '../report-data.service';

@Component({
  selector: 'app-metadata',
  templateUrl: './metadata.component.html',
  styleUrls: ['./metadata.component.css']
})
export class MetadataComponent implements OnInit, OnDestroy, AfterViewInit {
  columns: Array<Object>;
  cells: Array<Object>;
  rowHeaders: Array<String>;
  report: Report;
  data: any;
  reloadSubscription: ISubscription;

  constructor(private reportService: ReportDataService, private gridContext: HotRegisterer) {
  }

  ngOnInit() {
    this.report = this.reportService.getReport();
    this.columns = this.report.ReportMetadata.columns;
    this.cells = [
      {row: 0, col: 0, type: 'text', required: 'true', allowEmpty: false, readOnly: true}, //Classification
      {row: 3, col: 0, type: 'dropdown', source: this.report.lookups.MILESTONE}, //PhaseMSId
      {row: 16, col: 0, type: 'dropdown', source: this.report.lookups.CONTRACT_TYPE}, //Contract Type
      {row: 17, col: 0, type: 'numeric'}, //ContractPrice
      {row: 18, col: 0, type: 'numeric'}, //ContractCeiling
      {row: 20, col: 0, type: 'date', dateFormat: 'MM/DD/YYYY', correctFormat: true}, //PoP Start
      {row: 21, col: 0, type: 'date', dateFormat: 'MM/DD/YYYY', correctFormat: true}, //PoP End
      {row: 22, col: 0, type: 'dropdown', source: this.report.lookups.REPORT_CYCLE}, //ReportCycleID
      {row: 23, col: 0, type: 'numeric'}, //Submission Event #
      {row: 25, col: 0, type: 'checkbox'}, //Is Wildcard
      {row: 26, col: 0, type: 'numeric'}, //ReSubmission #
      {row: 27, col: 0, type: 'date', dateFormat: 'MM/DD/YYYY', correctFormat: true}, //as of date
      {row: 32, col: 0, type: 'date', dateFormat: 'MM/DD/YYYY', correctFormat: true}, //submission date
      {row: 33, col: 0, type: 'numeric', allowEmpty: false, invalidCellClassName: 'err-underline'} //ReportingPeriodID
    ];
    this.rowHeaders = this.report.ReportMetadata.rowHeaders;
    this.data = this.report.ReportMetadata.data;
  //  this.reloadSubscription = this.reportService.getReload().subscribe(data => this.reload());
  }

  ngOnDestroy() {
   // this.reloadSubscription.unsubscribe();
  }

  ngAfterViewInit() {
    //  this.reload();
  }

  reload() {
    this.data = this.report.ReportMetadata.data;
    const gridInstance = this.gridContext.getInstance('Metadata');
    gridInstance.loadData(this.data);
  }
}



// WEBPACK FOOTER //
// ./src/app/metadata/metadata.component.ts